// Sentry removed in Gatsby v5 migration; provide no-op fallbacks to avoid runtime errors
export const setUserForErrorLogging = () => {};

export const clearUserForErrorLogging = () => {};

export const captureException = () => {};

export const captureMessage = () => {};
